<template>
    <div class="auth-wrapper">
  <div class="auth-container">
    <h2>Verificar código</h2>
    <form @submit.prevent="verifyCode">
      <label for="code">Código recebido</label>
      <input
        v-model="code"
        type="text"
        id="code"
        required
        placeholder="Ex: 123456"
      />

      <button type="submit" :disabled="loading" class="btn-submit">
        <span v-if="loading">
          <i class="fas fa-spinner fa-spin"></i> Verificando...
        </span>
        <span v-else>Continuar</span>
      </button>

      <div class="links">
        <router-link to="/forgot-password">Reenviar código</router-link>
      </div>
    </form>
  </div>
    </div>
</template>

<script>
import { useAlertStore } from '@/stores/alertStore';
import api from '@/services/api';

export default {
  name: 'VerifyCode',
  data() {
    return {
      code: '',
      loading: false,
    };
  },
  methods: {
    async verifyCode() {
      const alert = useAlertStore();
      this.loading = true;
      try {
        alert.loading(true);
        await api.post('/auth/verify-code', { code: this.code });
        alert.show('Código verificado com sucesso!');
        this.$router.push('/reset-password'); // defina essa rota
      } catch (error) {
        alert.show('Código inválido ou expirado.');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.auth-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f5f5f5;
  padding: 20px;
  box-sizing: border-box;
}

.auth-container {
  width: 100%;
  max-width: 400px;
  padding: 30px;
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  color: #32355d;
}

h2 {
  margin-bottom: 20px;
  color: #f78da7;
  text-align: center;
}

form {
  display: flex;
  flex-direction: column;
}

label {
  margin: 12px 0 4px;
}

input {
  padding: 10px;
  border: 1px solid #dcdcdc;
  border-radius: 5px;
  font-size: 14px;
}

button {
  margin-top: 20px;
  padding: 12px;
  background-color: #f78da7;
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background-color: #e06c8b;
}

.btn-submit {
  background-color: #f78da7;
  color: white;
  border: none;
  padding: 12px 20px;
  font-size: 16px;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 20px;
}

.links {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 14px;
  text-align: center;
}

.links a {
  color: #32355d;
  text-decoration: none;
}

.links a:hover {
  text-decoration: underline;
}
</style>
